export default __webpack_public_path__ + "static/media/instagram-logo.883b4871.svg";